import {
  getCommentableRect,
  getDraggableShift,
  getEventOffset,
  getLocalPosition,
} from '@components/ArtBoard/Threads/utils'
import type { ID, Offset } from '@octopus-do/octopus-project-core'
import { ThreadsActions } from '@store/reducers/threads'
import type { MouseEvent } from 'react'
import type { DraggableData, DraggableEvent } from 'react-draggable'
import { useDispatch } from 'react-redux'

import { useScaleZoom } from '@/hooks'

export const useThreadDrop = (id: ID, prevCommentable: ID) => {
  const dispatch = useDispatch()

  const { scale } = useScaleZoom()
  const treeEl = document.getElementById('tree')

  const onDrop = (next: Offset, _ev: DraggableEvent, data: DraggableData) => {
    const event = _ev as MouseEvent
    if (!treeEl) {
      return
    }

    const eventOffset = getEventOffset(event)

    const [commentable, rect] = getCommentableRect(eventOffset, treeEl)

    const sameParent = commentable === prevCommentable

    const offset = sameParent
      ? next
      : getLocalPosition(
          eventOffset,
          rect,
          scale,
          getDraggableShift(event, data)
        )

    dispatch(
      ThreadsActions.move({
        uuid: id,
        offset,
        commentable,
      })
    )
  }

  return { onDrop }
}
